import {useEffect, useState,useContext} from "react";
import {useHistory} from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import {makeStyles} from "@material-ui/core/styles";
import {GeneralesContext} from '../context/GeneralesContext'
import { Box, Button, Card, CardContent, Grid,
    IconButton, LinearProgress, Paper, Tooltip,
    Typography, MenuItem, Select, TextField, FormControl, InputLabel} from "@material-ui/core";
import TablaAfiliados from "./TablaAfiliados";
import Relojes from "./Relojes";
import axios from "axios";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken,} from "../funciones/ClienteAxios";
import Galeria from "./Galeria";
import {AddCircleOutlined} from "@material-ui/icons";
import ClearIcon from '@material-ui/icons/Clear';
import ModalAgregarRecorrido from "./ModalNvo";
import ModalAgregarEvidencia from "./ModalAgregarEvidencia";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ModalNvoPerfilImg from "../prbImg/ModalNvoPerfImg";
import CardTotal from "./CardTotal";
const useStyles = makeStyles((theme) => ({}));

const Afiliado = () => {
    const classes = useStyles();
    const idusu = localStorage.getItem("UsuId");
    const history = useHistory();
    const source = axios.CancelToken.source();
    const avTot= {Avance:2200, Meta:42112, EdoAvc:3, MunAvc:450, SecAvc:8045, EdoTot:32, MunTot:4200, SecTot:32000}
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({
        inicio: new Date(),
        final: new Date(),
    });
    const {generales, guardarGenerales} = useContext(GeneralesContext);
    const [selectedID, setSelectedID] = useState(null);
    const [recorrido, setRecorrido] = useState([]);
    const [galeria, setGaleria] = useState([]);
    const [filtro, setFiltro] = useState({muni:0, secc:0, distrito:0});
    const [listMun, setListMun] = useState([]);
    const [listSec, setListSec] = useState([]);
    const [listDistrito, setListDistrito] = useState([]);
    const [latitud, setLatitud] = useState(0);
    const [longitud, setLongitud] = useState(0);
    const [cargando, setCargando] = useState(false);
    const [cargando2, setCargando2] = useState(false);
    const [abrirModalMapa, setAbrirModalMapa] = useState(false);
    const [abrirModalAgregar, setAbrirModalAgregar] = useState(false);
    const [modalPrb, setModalPrb] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [buscar, setBuscar] = useState(true);
    const [checked, setChecked] = useState(false);
    const [abrirModal, setAbrirModal] = useState(false);
    const [update, setUpdate] = useState(false);
    const [auxIp, setAuxIp] = useState("127.0.0.0");
    const{muni , secc , distrito } = filtro
    
    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setLatitud(position.coords.latitude);
                setLongitud(position.coords.longitude);
            });
        } else {
           // console.log("Not Available");
            setLatitud(0);
            setLongitud(0);
        }
        setAuxIp(generales?.ip ?generales.ip: "127.0.0.0")    
        getListMun()
        getListDistrito()
        guardarGenerales({...generales, Titulo: 'Afiliados'})
    }, []);


    useEffect(() => {
        setGaleria([]);

        const consultarImagenes = () => {
            const data = qs.stringify({
                Llave: selectedID,
                Usuario: idusu,
                idDispositivo: "987gyubjhkkjh",
                ip:generales?.ip ?generales.ip: "127.0.0.0",
            });
            const url = "afiliacion/file/list";

            function respuesta(response) {
                if (response[0].Id === -1) {
                    setGaleria([]);
                    setMensaje("Sin fotografías.");
                } else {
                    setGaleria(response);
                }
            }

            llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
        };
        if (selectedID !== null) {
            consultarImagenes();
        }
    }, [selectedID,update]);

    

      
    const getListMun = () => {
        const data = qs.stringify({            
            Usuario: idusu,
            Estado:13,
            idDispositivo: "987gyubjhkkjh",
            ip:generales?.ip ?generales.ip: "127.0.0.0",
        });
        const url = "lugar/municipio";

        function respuesta(response) {
            if (response[0].Id !== -1) {
                
                setListMun(response);
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando2, history, source);
    };

    const getListDistrito = () => {
        const data = qs.stringify({            
            Usuario: idusu,
            Estado:13,
            idDispositivo: "987gyubjhkkjh",
            ip:auxIp,
        });
        const url = "lugar/distrito";

        function respuesta(response) {
            if (response[0].Id !== -1) {
                
                setListDistrito(response);
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando2, history, source);
    };

    const getListSecc = (municipio) => {
        const data = qs.stringify({            
            Usuario: idusu,            
            Municipio:municipio,
            idDispositivo: "987gyubjhkkjh",
            ip:generales?.ip ?generales.ip: "127.0.0.0",
        });
        const url = "lugar/seccion/municipio";

        function respuesta(response) {
            if (response[0].Id !== -1) {
                
                setListSec(response);
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando2, history, source);
    };

    const guardarMuni = (e) => {
        if (e !== null && e !== undefined) {
            getListSecc(e.Id)
            setFiltro({
                ...filtro,
                muni: e,
                secc: ""
            })            
        } else {
            setFiltro({
                ...filtro,
                muni: "", secc: ""
            })
            setListSec([])
        }
    }

    const guardarSeccion = (e) => {
        if (e !== null && e !== undefined) {
            setFiltro({
                ...filtro,
                secc: e.target.value
            })
         
        } else {
            setFiltro({
                ...filtro,
                secc: 0
            })
        }
    }

    const buscarDatos = () => {
        setBuscar(!buscar)
    }
    
    const limpioFiltro=()=>{
        setFiltro({ ...filtro, distrito:0, muni: 0, secc: 0 })
        setListSec([])
    }

    const modalAgregarEvidencia = abrirModal ? <ModalAgregarEvidencia abrirModal={abrirModal}
                                                setAbrirModal={setAbrirModal} recorrido={recorrido}
                                                selectedID={selectedID} idusu={idusu}  setUpdate={setUpdate}
                                            /> : null

    const modalAgregarRecorrido = abrirModalAgregar ? <ModalAgregarRecorrido abrirModal={abrirModalAgregar}
                                                        setAbrirModal={setAbrirModalAgregar}
                                                        idusu={idusu} history={history}
                                                        source={source} latitud={latitud}
                                                        longitud={longitud} actualiza={buscarDatos}
                                                    /> : null

    const agregarDatos = () => {
        setAbrirModalAgregar(true)
    }

    const listarGaleria =
        galeria.length > 0 ? (
            <Galeria
                galeria={galeria}
            />
        ) : (
            <Paper className={classes.root}>
                <Typography variant={"h5"}>{mensaje}</Typography>
            </Paper>
        );

    const handleChange = () => {
        setChecked(!checked)
    };

    const handleAbrir = () => {
        setAbrirModal(true)
    }

    const modalPrbImg= modalPrb ? <ModalNvoPerfilImg modalAbierto={modalPrb} setModalAbierto={setModalPrb}  titulo="image"  /> :null
    const principal = () => {
        return (
            <Grid container spacing={1}>
                {modalPrbImg}
                {modalAgregarRecorrido}
                <Grid item xs={12}>
                    <Card>
                        <CardContent style={{padding:0.4+'rem'}} >
                            <Grid container spacing={1} alignItems={'center'}>
                                <Grid item>
                                    <Button onClick={buscarDatos} 
                                        style={{width:"7rem", marginRight:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}} 
                                        variant="contained"  color="primary"  startIcon={<SearchIcon/>} >   
                                        Buscar     
                                    </Button>
                                    {/* <Tooltip title={'Buscar'}>                                        
                                        <IconButton style={{color:process.env.REACT_APP_Btn_Color}}
                                            color="primary"
                                            aria-label="Buscar"
                                            onClick={buscarDatos}
                                        >
                                            <SearchIcon/>
                                        </IconButton>
                                    </Tooltip> */}
                                </Grid>
                    
                                <Grid item>
                                    <Relojes
                                        fechasSeleccionadas={fechasSeleccionadas}
                                        setFechasSeleccionadas={setFechasSeleccionadas}
                                    />
                                </Grid>
                                 <Grid item>
                                    {listMun.length !== 0 ?
                                        <Autocomplete
                                            id="muni-select-nvoPerfil" size='small' style={{width:"22rem"}}
                                            onChange={(e, option) => guardarMuni(option)} value={muni}
                                            getOptionLabel={(option) => option.Nom} name="Municipio"
                                            noOptionsText={"Sin coincidencias"} options={listMun}
                                            renderInput={(params) => (
                                                <TextField {...params} size='small'
                                                    label="Municipio" variant="outlined"/>
                                            )}
                                        />
                                    : <LinearProgress/>}
                        
                                </Grid> 
                                <Grid>
                                {listSec.length !== 0 ? 
                                <FormControl size='small'>
                                    <InputLabel size='small' variant="outlined" id="Seccion-label-nvo">Sección</InputLabel>
                                    <Select size='small' variant="outlined" style={{width: '7rem'}}
                                        label="Sección" id="Seccion-select2" name="secc"
                                        value={secc} onChange={guardarSeccion}
                                        fullWidth
                                    >
                                        {listSec.map((seccion, index) => {
                                            return (
                                            <MenuItem size='small' value={seccion.Id} key={seccion.Id}>
                                                <em>{seccion.Numero}</em>
                                            </MenuItem>
                                            )
                                            }
                                        )}
                                    </Select>
                                </FormControl>
                                :null}
                                </Grid>
                                {distrito!==0 || (muni!==0 && muni!=="" )|| secc!==0 ?
                                <Grid item>
                                    <Tooltip title={'Limpiar filtros'}>
                                        <IconButton
                                            color="primary"
                                            aria-label="Limpiar filtros"
                                            onClick={limpioFiltro}
                                        >
                                            <ClearIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                :null}
                               {/*   <Grid item>
                                    <Tooltip title={'Agregar Recorrido'}>
                                        <IconButton
                                            color="primary"
                                            aria-label="Agregar Recorrido"
                                            onClick={agregarDatos}
                                        >
                                            <AddCircleOutlined/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid> */}
                                
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                { avTot.length !== 0 ?
                    <Grid item xs={12}>
                        <CardTotal valor={avTot}/>
                    </Grid>
                    :null
                }
                <Grid item xs={9}>
                    <TablaAfiliados auxIp={generales?.ip ?generales.ip: "127.0.0.0"}
                        history={history} setRecorrido={setRecorrido}
                        fechasSeleccionadas={fechasSeleccionadas}
                        selectedID={selectedID} setSelectedID={setSelectedID}
                        source={source} idusu={idusu} buscar={buscar}
                        checked={checked} abrirModal={abrirModalMapa}
                        setAbrirModal={setAbrirModalMapa}
                        listMun={listMun}
                        muni={muni} secc={secc} distrito={distrito}
                    />
                </Grid>
                <Grid item xs={3}>
                    {modalAgregarEvidencia}
                    {/* recorrido.Obsrv ? 
                        cargando ? (
                            <Box mt={2} mb={2} width="80%">
                                <LinearProgress/>
                            </Box>
                        ) 
                        : (
                            <Grid container>
                            <Grid item xs={12} style={{paddingBottom: 10}}>
                                <Typography color="primary">
                                    Observación
                                </Typography>
                                <Typography>
                                    {recorrido?.Obsrv}
                                </Typography>
                            </Grid>
                            </Grid>
                        ) 
                    :null */}
                    {/* selectedID !== null ? <Grid container>
                        <Grid item xs={12} style={{paddingBottom: 10}}>
                            <Button
                                variant="contained" color="primary"
                                startIcon={<AddCircleOutlined/>}
                                onClick={handleAbrir}
                            >
                                Subir Fotos
                            </Button>
                        </Grid>
                    </Grid> : null */}
                    {cargando ? (
                        <Box pl={1} pt={5}>
                            <LinearProgress/>
                        </Box>
                    ) : (
                        listarGaleria
                    )}
                </Grid>
            </Grid>
        );
    };

    return <div>{principal()}</div>;
};

export default Afiliado;
